var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSideSliderArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20 0C8.97219 0 0 8.97219 0 20C0 31.0278 8.97219 40 20 40C31.0278 40 40 31.0278 40 20C40 8.97219 31.0278 0 20 0ZM20 37.5C10.3503 37.5 2.5 29.6497 2.5 20C2.5 10.3503 10.3503 2.5 20 2.5C29.6497 2.5 37.5 10.3503 37.5 20C37.5 29.6497 29.6497 37.5 20 37.5ZM28.3838 19.1163C28.4999 19.2323 28.592 19.37 28.6549 19.5217C28.7178 19.6733 28.7501 19.8358 28.7501 20C28.7501 20.1642 28.7178 20.3267 28.6549 20.4783C28.592 20.63 28.4999 20.7677 28.3838 20.8838L22.1338 27.1338C21.8897 27.3778 21.5697 27.5 21.25 27.5C20.9303 27.5 20.6103 27.3778 20.3662 27.1338C20.2501 27.0177 20.158 26.88 20.0951 26.7283C20.0322 26.5767 19.9999 26.4142 19.9999 26.25C19.9999 26.0858 20.0322 25.9233 20.0951 25.7717C20.158 25.62 20.2501 25.4823 20.3662 25.3662L24.4825 21.25H12.5C11.8097 21.25 11.25 20.6909 11.25 20C11.25 19.3091 11.8097 18.75 12.5 18.75H24.4825L20.3662 14.6337C19.8778 14.1453 19.8778 13.3544 20.3662 12.8663C20.8547 12.3781 21.6456 12.3778 22.1338 12.8663L28.3838 19.1163Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideSliderArrow);
export default __webpack_public_path__ + "static/media/side_slider_arrow.ce9d80cb7e99206fc7cab367feaa40c4.svg";
export { ForwardRef as ReactComponent };